export const imageURL= "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/"
export const Fetchmenu = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=11.31973&lng=75.80146549999999&restaurantId="

export const restaurantList=[
    {    
            "info": {
              "id": "359066",
              "name": "Pizza Hut",
              "cloudinaryImageId": "2b4f62d606d1b2bfba9ba9e5386fabb7",
              "locality": "Indira Gandhi Road",
              "areaName": "Arayidathupalam",
              "costForTwo": "₹500 for two",
              "cuisines": [
                "Pizzas"
              ],
              "avgRating": 4.1,
              "parentId": "721",
              "avgRatingString": "4.1",
              "totalRatingsString": "1K+",
              "sla": {
                "deliveryTime": 42,
                "lastMileTravel": 8.9,
                "serviceability": "SERVICEABLE",
                "slaString": "40-45 mins",
                "lastMileTravelString": "8.9 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-04-25 00:00:00",
                "opened": true
              },
              "badges": {
                "imageBadges": [
                  {
                    "imageId": "Rxawards/_CATEGORY-Pizza.png",
                    "description": "Delivery!"
                  }
                ]
              },
              "isOpen": true,
              "type": "F",
              "badgesV2": {
                "entityBadges": {
                  "imageBased": {
                    "badgeObject": [
                      {
                        "attributes": {
                          "description": "Delivery!",
                          "imageId": "Rxawards/_CATEGORY-Pizza.png"
                        }
                      }
                    ]
                  },
                  "textBased": {
                    
                  },
                  "textExtendedBadges": {
                    
                  }
                }
              },
              "aggregatedDiscountInfoV3": {
                "header": "50% OFF",
                "subHeader": "UPTO ₹100"
              },
              "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                  "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                  "lottie": {
                    
                  },
                  "video": {
                    
                  }
                }
              },
              "reviewsSummary": {
                
              },
              "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
              "restaurantOfferPresentationInfo": {
                
              }
            },
            "analytics": {
              
            },
            "cta": {
              "link": "https://www.swiggy.com/restaurants/pizza-hut-indira-gandhi-road-arayidathupalam-kozhikode-359066",
              "type": "WEBLINK"
            }
          },
          {
            "info": {
              "id": "490981",
              "name": "Top Form_Mavoor Road",
              "cloudinaryImageId": "b5303a94c367062c158ce278bf6307a3",
              "locality": "Mavoor Road",
              "areaName": "Kuttichira",
              "costForTwo": "₹400 for two",
              "cuisines": [
                "South Indian",
                "Kerala",
                "Biryani",
                "Chinese",
                "Salads",
                "Seafood"
              ],
              "avgRating": 4.4,
              "parentId": "454775",
              "avgRatingString": "4.4",
              "totalRatingsString": "10K+",
              "sla": {
                "deliveryTime": 36,
                "lastMileTravel": 9.6,
                "serviceability": "SERVICEABLE",
                "slaString": "35-40 mins",
                "lastMileTravelString": "9.6 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-04-25 02:00:00",
                "opened": true
              },
              "badges": {
                "imageBadges": [
                  {
                    "imageId": "Rxawards/_CATEGORY-Biryani.png",
                    "description": "Delivery!"
                  }
                ]
              },
              "isOpen": true,
              "aggregatedDiscountInfoV2": {
                
              },
              "type": "F",
              "badgesV2": {
                "entityBadges": {
                  "imageBased": {
                    "badgeObject": [
                      {
                        "attributes": {
                          "description": "Delivery!",
                          "imageId": "Rxawards/_CATEGORY-Biryani.png"
                        }
                      }
                    ]
                  },
                  "textBased": {
                    
                  },
                  "textExtendedBadges": {
                    
                  }
                }
              },
              "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                  "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                  "lottie": {
                    
                  },
                  "video": {
                    
                  }
                }
              },
              "reviewsSummary": {
                
              },
              "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
              "restaurantOfferPresentationInfo": {
                
              }
            },
            "analytics": {
              
            },
            "cta": {
              "link": "https://www.swiggy.com/restaurants/top-form-mavoor-road-mavoor-road-kuttichira-kozhikode-490981",
              "type": "WEBLINK"
            }
          },
          {
            "info": {
              "id": "395946",
              "name": "Kuttichira Biriyani Centre",
              "cloudinaryImageId": "xywyltlvxs5pagooukuo",
              "locality": "Mavoor Road",
              "areaName": "Jafar Khan Colony",
              "costForTwo": "₹249 for two",
              "cuisines": [
                "Biryani",
                "South Indian"
              ],
              "avgRating": 4.3,
              "parentId": "122112",
              "avgRatingString": "4.3",
              "totalRatingsString": "5K+",
              "sla": {
                "deliveryTime": 34,
                "lastMileTravel": 8.6,
                "serviceability": "SERVICEABLE",
                "slaString": "30-35 mins",
                "lastMileTravelString": "8.6 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-04-24 18:00:00",
                "opened": true
              },
              "badges": {
                "imageBadges": [
                  {
                    "imageId": "Rxawards/_CATEGORY-Biryani.png",
                    "description": "Delivery!"
                  }
                ]
              },
              "isOpen": true,
              "type": "F",
              "badgesV2": {
                "entityBadges": {
                  "imageBased": {
                    "badgeObject": [
                      {
                        "attributes": {
                          "description": "Delivery!",
                          "imageId": "Rxawards/_CATEGORY-Biryani.png"
                        }
                      }
                    ]
                  },
                  "textBased": {
                    
                  },
                  "textExtendedBadges": {
                    
                  }
                }
              },
              "aggregatedDiscountInfoV3": {
                "header": "20% OFF",
                "subHeader": "UPTO ₹50"
              },
              "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                  "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                  "lottie": {
                    
                  },
                  "video": {
                    
                  }
                }
              },
              "reviewsSummary": {
                
              },
              "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
              "restaurantOfferPresentationInfo": {
                
              }
            },
            "analytics": {
              
            },
            "cta": {
              "link": "https://www.swiggy.com/restaurants/kuttichira-biriyani-centre-mavoor-road-jafar-khan-colony-kozhikode-395946",
              "type": "WEBLINK"
            }
          },
          {
            "info": {
              "id": "382724",
              "name": "New Malabar Family Restaurant",
              "cloudinaryImageId": "dypfwfzd1seuqyanabsv",
              "locality": "Karaparamba",
              "areaName": "Bilathikkulam",
              "costForTwo": "₹300 for two",
              "cuisines": [
                "Chinese",
                "North Indian",
                "South Indian",
                "Biryani"
              ],
              "avgRating": 4.4,
              "parentId": "251724",
              "avgRatingString": "4.4",
              "totalRatingsString": "5K+",
              "sla": {
                "deliveryTime": 29,
                "lastMileTravel": 4.8,
                "serviceability": "SERVICEABLE",
                "slaString": "25-30 mins",
                "lastMileTravelString": "4.8 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-04-24 23:00:00",
                "opened": true
              },
              "badges": {
                
              },
              "isOpen": true,
              "type": "F",
              "badgesV2": {
                "entityBadges": {
                  "imageBased": {
                    
                  },
                  "textBased": {
                    
                  },
                  "textExtendedBadges": {
                    
                  }
                }
              },
              "aggregatedDiscountInfoV3": {
                "header": "₹40 OFF",
                "subHeader": "ABOVE ₹499",
                "discountTag": "FLAT DEAL"
              },
              "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                  "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                  "lottie": {
                    
                  },
                  "video": {
                    
                  }
                }
              },
              "reviewsSummary": {
                
              },
              "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
              "restaurantOfferPresentationInfo": {
                
              }
            },
            "analytics": {
              
            },
            "cta": {
              "link": "https://www.swiggy.com/restaurants/new-malabar-family-restaurant-karaparamba-bilathikkulam-kozhikode-382724",
              "type": "WEBLINK"
            }
          },
    ]